import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadMonitor: IMonitorLoadActionCreator = () => {
        return {
            type: ACTION_MONITOR_LOAD
        }
    },
    LoadMonitorsByMonitoringId: IMonitorsLoadByMonitoringIdActionCreator = (monitoringId) => {
        return {
            type: ACTION_MONITORS_LOAD_BY_MONITORING_ID,
            monitoringId
        }
    },
    LoadMonitorById: IMonitorLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_MONITOR_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IMonitorLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_MONITOR_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IMonitorLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_MONITOR_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveMonitor: IMonitorSaveActionCreator = (formData) => {
        return {
            type: ACTION_MONITOR_SAVE,
            formData
        }
    },
    SaveSuccess: IMonitorSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_MONITOR_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IMonitorSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_MONITOR_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateMonitor: IMonitorCreateActionCreator = (monitoringId) => {

        return {
            type: ACTION_MONITOR_CREATE,
            monitoringId
        }
    },
    CreateSuccess: IMonitorCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_MONITOR_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IMonitorCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_MONITOR_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateMonitor: IMonitorValidateActionCreator = (formData) => {
        return {
            type: ACTION_MONITOR_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IMonitorValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_MONITOR_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IMonitorValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_MONITOR_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: IMonitorClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_MONITOR_CLEAR,
            propertiesToClear
        }
    },

    Filter: IMonitorFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_MONITOR_FILTER,
            formFilter
        }
    };



export const
    ACTION_MONITOR_LOAD = "ACTION_MONITOR_LOAD",
    ACTION_MONITORS_LOAD_BY_MONITORING_ID = "ACTION_MONITORS_LOAD_BY_MONITORING_ID",
    ACTION_MONITOR_LOAD_BY_ID = "ACTION_MONITOR_LOAD_BY_ID",
    ACTION_MONITOR_LOAD_SUCCESS = "ACTION_MONITOR_LOAD_SUCCESS",
    ACTION_MONITOR_LOAD_FAILURE = "ACTION_MONITOR_LOAD_FAILURE",

    ACTION_MONITOR_SAVE = "ACTION_MONITOR_SAVE",
    ACTION_MONITOR_SAVE_SUCCESS = "ACTION_MONITOR_SAVE_SUCCESS",
    ACTION_MONITOR_SAVE_FAILURE = "ACTION_MONITOR_SAVE_FAILURE",

    ACTION_MONITOR_CREATE = "ACTION_MONITOR_CREATE",
    ACTION_MONITOR_CREATE_SUCCESS = "ACTION_MONITOR_CREATE_SUCCESS",
    ACTION_MONITOR_CREATE_FAILURE = "ACTION_MONITOR_CREATE_FAILURE",

    ACTION_MONITOR_VALIDATE = "ACTION_MONITOR_VALIDATE",
    ACTION_MONITOR_VALIDATE_SUCCESS = "ACTION_MONITOR_VALIDATE_SUCCESS",
    ACTION_MONITOR_VALIDATE_FAILURE = "ACTION_MONITOR_VALIDATE_FAILURE",

    ACTION_MONITOR_CLEAR = "ACTION_MONITOR_CLEAR",

    ACTION_MONITOR_FILTER = "ACTION_MONITOR_FILTER";

export interface IMonitorLoadAction {
    type: "ACTION_MONITOR_LOAD";
}

export interface IMonitorLoadActionCreator {
    (): IMonitorLoadAction;
}

export interface IMonitorLoadSuccessAction {
    type: "ACTION_MONITOR_LOAD_SUCCESS";
    formData: Dtos.Monitor | Dtos.Monitor[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IMonitorLoadSuccessActionCreator {
    (
        formData: Dtos.Monitor | Dtos.Monitor[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IMonitorLoadSuccessAction;
}

export interface IMonitorLoadFailureAction {
    type: "ACTION_MONITOR_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IMonitorLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IMonitorLoadFailureAction;
}

export interface IMonitorsLoadByMonitoringIdAction {
    type: "ACTION_MONITORS_LOAD_BY_MONITORING_ID";
    monitoringId: number;
}

export interface IMonitorsLoadByMonitoringIdActionCreator {
    (monitoringId: number): IMonitorsLoadByMonitoringIdAction;
}

export interface IMonitorLoadByIdAction {
    type: "ACTION_MONITOR_LOAD_BY_ID";
    id: number;
}

export interface IMonitorLoadByIdActionCreator {
    (id: number): IMonitorLoadByIdAction;
}


export interface IMonitorSaveAction {
    type: "ACTION_MONITOR_SAVE";
    formData: Dtos.Monitor;

}

export interface IMonitorSaveActionCreator {
    (
        formData: Dtos.Monitor
    ): IMonitorSaveAction;
}

export interface IMonitorSaveSuccessAction {
    type: "ACTION_MONITOR_SAVE_SUCCESS";
    formData: Dtos.Monitor;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IMonitorSaveSuccessActionCreator {
    (
        formData: Dtos.Monitor,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IMonitorSaveSuccessAction;
}

export interface IMonitorSaveFailureAction {
    type: "ACTION_MONITOR_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IMonitorSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IMonitorSaveFailureAction;
}

export interface IMonitorCreateAction {
    type: "ACTION_MONITOR_CREATE",
    monitoringId: number
}

export interface IMonitorCreateActionCreator {
    (monitoringId: number): IMonitorCreateAction
}

export interface IMonitorCreateSuccessAction {
    type: "ACTION_MONITOR_CREATE_SUCCESS";
    formData: Dtos.Monitor;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface IMonitorCreateSuccessActionCreator {
    (
        formData: Dtos.Monitor,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IMonitorCreateSuccessAction;
}

export interface IMonitorCreateFailureAction {
    type: "ACTION_MONITOR_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IMonitorCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IMonitorCreateFailureAction;
}

export interface IMonitorValidateAction {
    type: "ACTION_MONITOR_VALIDATE";
    formData: Dtos.Monitor;

}

export interface IMonitorValidateActionCreator {
    (
        formData: Dtos.Monitor
    ): IMonitorValidateAction;
}

export interface IMonitorValidateSuccessAction {
    type: "ACTION_MONITOR_VALIDATE_SUCCESS";
    formData: Dtos.Monitor;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IMonitorValidateSuccessActionCreator {
    (
        formData: Dtos.Monitor,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IMonitorValidateSuccessAction;
}

export interface IMonitorValidateFailureAction {
    type: "ACTION_MONITOR_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IMonitorValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IMonitorValidateFailureAction;
}

export interface IMonitorClearAction {
    type: "ACTION_MONITOR_CLEAR";
    propertiesToClear?: string[];
}

export interface IMonitorClearActionCreator {
    (propertiesToClear?: string[]): IMonitorClearAction;
}

export interface IMonitorFilterActionCreator {
    (formFilter: IFormFilter): IMonitorFilterAction;
}

export interface IMonitorFilterAction {
    type: "ACTION_MONITOR_FILTER";
    formFilter: IFormFilter;
}

export type MonitorAction =
    IMonitorLoadAction |
    IMonitorsLoadByMonitoringIdAction |
    IMonitorLoadByIdAction |
    IMonitorLoadFailureAction |
    IMonitorLoadSuccessAction |
    IMonitorSaveAction |
    IMonitorSaveSuccessAction |
    IMonitorSaveFailureAction |
    IMonitorCreateAction |
    IMonitorCreateSuccessAction |
    IMonitorCreateFailureAction |
    IMonitorValidateAction |
    IMonitorValidateSuccessAction |
    IMonitorValidateFailureAction |
    IMonitorClearAction | 
    IMonitorFilterAction;
